import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { resetData } from "../../features/login/LoginSlice";

export const useNavbar = () => {
  const { modules } = useSelector((state) => state.loginSlice);
  const dispatch = useDispatch();
  console.log(modules);

  const navigate = useNavigate();
  const [openAlert, setOpenAlert] = useState(false);
  const [tabs, setTabs] = useState(modules);
  const catalogIndex = tabs.findIndex((item) => item.sModuleName === "Catalog");
  const [openIndex, setOpenIndex] = useState(catalogIndex);

  const handleItemClick = (index) => {
    if (openIndex === index) {
      setOpenIndex(null);
    } else {
      setOpenIndex(index);
    }
  };

  useEffect(() => {
    setTabs(modules);
  }, [modules]);

  const handleLogout = () => {
    setOpenAlert(false);
    dispatch(resetData());
    navigate("/login", { replace: true });
  };

  const handleClose = () => {
    setOpenAlert(false);
  };
  const handleOpen = () => {
    setOpenAlert(true);
  };

  return {
    openAlert,
    handleClose,
    handleLogout,
    handleOpen,
    tabs,
    handleItemClick,
    openIndex,
    setOpenIndex,
  };
};
